module.exports = __webpack_public_path__ + "static/media/Blastblight.496230f3.png";